import {VisuallyImpairedSettings} from '../../../models/visuallyImpairedSettings';
import {StorageKeys} from '../../../storage';

export const visuallyImpairedSettingsToStorageKey = (key: string): StorageKeys | null => {
  switch (key) {
    case 'fontSize':
      return StorageKeys.fontSize;
    case 'visuallyImpaired':
      return StorageKeys.visuallyImpaired;
    case 'switchColor':
      return StorageKeys.switchColor;
    case 'switchImages':
      return StorageKeys.switchImages;
    case 'letterSpacing':
      return StorageKeys.letterSpacing;
    case 'fontStyle':
      return StorageKeys.fontStyle;
    default:
      return null;
  }
};

export const getValueForKey = (key: string, value: string) => {
  switch (key) {
    case StorageKeys.fontSize: {
      return value;
    }
    case StorageKeys.visuallyImpaired: {
      return +value;
    }
    case StorageKeys.switchColor: {
      return value;
    }
    case StorageKeys.switchImages: {
      return +value;
    }
    case StorageKeys.letterSpacing: {
      return value;
    }
    case StorageKeys.fontStyle: {
      return value;
    }
    default:
      return undefined;
  }
};

export const visuallyImpairedSettingsValue = (
  initialValues: VisuallyImpairedSettings,
  values: Partial<Record<StorageKeys, any>>,
): VisuallyImpairedSettings => {
  const result = {
    ...initialValues,
  };
  for (const key in values) {
    result[key] = getValueForKey(key, values[key as StorageKeys]);
  }
  return result;
};
